import styled from "styled-components";

import { getFontFamily } from "../../Theme/utils.js";

const getScheme = p => p.theme.schemes.default.input[p.scheme];

export const Textarea = styled.textarea`
  width: 100%;
  padding: 10px 17px;
  font-size: 0.9rem;
  border: 2px solid
    ${p => (p.scheme ? getScheme(p).border : p.theme.colors.lighterGrey)};
  border-radius: 8px;
  color: ${p => (p.scheme ? getScheme(p).color : p.theme.colors.black)};
  background-color: ${p =>
    p.scheme ? getScheme(p).background : p.theme.colors.white};
  ${getFontFamily("regular")}
`;
